import React, { useEffect, useState } from "react";

import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { firebase } from "../firebase/firebase-config";
import { AuthRouter } from "./AuthRouter";
import { JournalScreen } from "../components/journal/JournalScreen";
import { useDispatch } from "react-redux";
import { login } from "../actions/auth";
import { PublicRoute } from "./PublicRoute";
import { PrivateRoute } from "./PrivateRoute";
import { startLoadingNotes } from "../actions/notes";

export const AppRouter = () => {
  const dispatch = useDispatch();

  const [checking, setChecking] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user?.uid) {
        dispatch(login(user.uid, user.displayName));
        setIsLoggedIn(true);
        dispatch(startLoadingNotes(user.uid));
      } else {
        setIsLoggedIn(false);
      }
      setChecking(false);
    });
  }, [dispatch, setChecking, setIsLoggedIn]);

  if (checking) {
    return <h1><i className="fa fa-spinner fa-spin" /> Wait...</h1>;
  }

  return (
    <div>
      <Router>
        <div>
          <Switch>
            <PublicRoute
              path="/JournalApp/auth"
              isAuthenticated={isLoggedIn}
              component={AuthRouter}
            />
            <PrivateRoute
              path="/JournalApp/"
              isAuthenticated={isLoggedIn}
              component={JournalScreen}
            />
            <Redirect to="/JournalApp/auth/login" />
          </Switch>
        </div>
      </Router>
    </div>
  );
};
